const _ = "styles-module__banner___-dbal", n = "styles-module__icon___DUBna", e = "styles-module__icon_close___Hwg2b", o = "styles-module__body___YQkMU", s = "styles-module__title___Z3bdR", l = "styles-module__link___fXxpH", t = {
  banner: _,
  "banner-warning": "styles-module__banner-warning___42zjB",
  icon: n,
  icon_close: e,
  body: o,
  title: s,
  link: l
};
export {
  _ as banner,
  o as body,
  t as default,
  n as icon,
  e as icon_close,
  l as link,
  s as title
};
